export enum CardLinkOfferType {
  AllOffers = 1,
  FeatureOffers = 2,
  OffersYouMayLike = 3,
  OtherOffers = 4,
  ActivatedOffers = 5,
  CustomOffersData = 6,
}
